<script setup lang="ts">
import type { HeroComponentModel } from '@su4r-frontend/api';
defineProps<HeroComponentModel>();

const localeRoute = useLocaleRoute();
</script>

<template>
    <section
        class="relative mb-45.5 grid w-full grid-cols-12 gap-y-0 rounded-lg bg-cover lg:mb-0 lg:overflow-hidden"
        :style="`background-image: url(${image?.url + '?width=1344&format=webp'}); background-size: scale; background-position: center; background-repeat: no-repeat;`">
        <div
            class="tile-bottom-right-large bg-blue-light/60 relative z-10 col-span-12 backdrop-blur-lg lg:col-span-6 lg:pb-6">
            <div class="flex flex-col gap-y-4">
                <header class="flex flex-col gap-4">
                    <h2 class="text-5xl lg:text-6xl">{{ header }}</h2>
                </header>

                <div v-html="description"></div>

                <NuxtLink
                    v-if="button"
                    :to="localeRoute(button.url)"
                    class="btn-primary-a"
                    :target="button.openInNewTab ? '_blank' : '_self'"
                    >{{ button.title }}</NuxtLink
                >

                <div
                    v-if="interregText || interregImage"
                    class="mt-8 flex flex-col gap-4 border-t border-t-black/10 pt-4 lg:flex-row lg:items-center">
                    <p v-if="interregText" class="text-sm">{{ interregText }}</p>
                    <img
                        v-if="interregImage"
                        :src="interregImage.url + '?height=40&format=webp'"
                        :alt="interregImage.alt ?? ''"
                        class="max-w-32" />
                </div>
            </div>
        </div>

        <img
            v-if="image"
            height="222"
            width="736"
            :src="image.url + '?width=736&height=222&format=webp'"
            :alt="image.alt ?? ''"
            class="absolute top-[calc(100%-40px)] col-span-12 block h-55.5 w-full rounded-b-lg object-cover object-top lg:top-0 lg:left-0 lg:mt-0 lg:hidden lg:h-full lg:object-cover" />
    </section>
</template>
